import { OverlayLoader } from 'components/Loaders'
import formName from 'constants/formName'
import { actions, selectors } from 'data'
import { TierTwoFormType, TierTwoStepType } from 'data/Form/TierTwo/types'
import isEqual from 'lodash/isEqual'
import omit from 'lodash/omit'
import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { InjectedFormProps, reduxForm } from 'redux-form'
import { ExtraKyc } from 'scenes/ExtraKYC'
import styled from 'styled-components'

import preventUserInputCss from '../Modal/PreventUserInput'
import AppComplete from './AppComplete'
import Edd from './Edd'
import Final from './Final'
import PreIdv from './PreIdv'
import Ssn from './Ssn'
import UKFrictions from './UKFrictions'
import Veriff from './Veriff'
import Welcome from './Welcome'

const stepComponent = {
  appComplete: AppComplete,
  edd: Edd,
  final: Final,
  preIdv: PreIdv,
  ssn: Ssn,
  veriff: Veriff,
  welcome: Welcome
}

type NotFormProps = {
  handleSubmit: (e) => void
  initialValues: TierTwoFormType
  isLoading: boolean
  isUS: boolean
  step: TierTwoStepType
}

// @ts-ignore FIXME circular ref on Props
type Props = InjectedFormProps<TierTwoFormType, NotFormProps> &
  NotFormProps &
  ConnectedProps<typeof connector>

const Form = styled.form<{ isLoading: boolean }>`
  ${preventUserInputCss};
  width: 100%;
`

class TierTwoForm extends React.Component<Props> {
  componentDidMount() {
    this.props.fetchExtraKyc()
  }

  shouldComponentUpdate(nextProps) {
    return !isEqual(omit(this.props, 'initialValues'), omit(nextProps, 'initialValues'))
  }

  render() {
    const { step, ...rest } = this.props
    const Step = stepComponent[step]

    if (this.props.isLoading) return <OverlayLoader />

    if (this.props.extraKYCQuestions)
      return <ExtraKyc context='TIER_TWO_VERIFICATION' onDone={this.props.onShowVerif} />

    if (this.props.ukFrictionsState !== null) {
      if (
        !this.props.ukFrictionsState.isUserFinishSelfClassification ||
        !this.props.ukFrictionsState.isUserFinishQuiz
      ) {
        return (
          <UKFrictions
            // @ts-ignore
            state={this.props.ukFrictionsState}
            onComplete={this.props.getUkFrictionsState}
          />
        )
      }
    }

    return (
      <Form isLoading={rest.isLoading} onSubmit={rest.handleSubmit}>
        <Step {...rest} steps={rest.isUS ? 4 : 3} />

        {rest.isLoading && <OverlayLoader />}
      </Form>
    )
  }
}

const mapStateToProps = (state) => ({
  extraKYCQuestions: selectors.auth.extraKYCQuestions.get(state),
  isLoading: selectors.tierTwo.isLoading(state),
  ukFrictionsState: selectors.auth.ukFrictions.get(state)
})

const mapDispatchToProps = (dispatch) => ({
  fetchExtraKyc: () => {
    dispatch(actions.auth.extraKYCQuestions.fetch('TIER_TWO_VERIFICATION'))
  },
  getUkFrictionsState: () => {
    dispatch(actions.auth.ukFrictions.fetch())
  },
  onShowVerif: () => {
    dispatch(actions.app.showModal('TIER_TWO'))
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)(TierTwoForm)

export default reduxForm<TierTwoFormType, NotFormProps>({
  form: formName.TIER_TWO
})(connector)
